import { Component, createRef } from 'preact'

import {
    widgetUrl,
    TENANTS
} from '../constants'
import Badge from './personalized/badge'
import CopyButton from './personalized/copy-button'
import { __ } from '../../locales'

const randomId = () =>
    Math.random().toString(36).replace(/[^a-z0-9]+/g, '').substr(0, 8);

class WidgetPreview extends Component {
    constructor(props) {
        super(props);
        this.state = {
            scriptLoaded: false,
            showScript: true,
            options: {
                widget_container_id: randomId(),
            }
        }
        this.codeRef = createRef()
    }
    componentWillUpdate() {
        if (this.state.scriptLoaded) {
            this.reinitScript();
        }
    }

    getQuery = () => {
        const { layoutType, inputs, extraParams, type  } = this.props;
        const options = { ...inputs, ...this.state.options, layoutType, type };
        // AU regulation: an empty link on the AU tenant is the "Disabled" option; signal it so the
        // widget renderer skips its profile-page fallback and renders no link at all.
        options.disableLink = inputs.tenant === TENANTS.AU.name && !inputs.linkUrl
        const params = [
            'widget_container_id',
            'type',
            'tenant',
            'language',
            'profileType',
            'layoutType',
            'disableLink',
            ...extraParams,
        ];
        return params.filter(f => !!options[f]).map(p => `${p}=${options[p]}`).join('&').replace(/#/g, '')
    };

    renderScript = () => {
        const { selectedTenant } = this.props
        return (
            <div className={'d-flex align-items-center flex-column'}>
                <div id={this.state.options.widget_container_id} style={{ width: '100%' }} className={'d-flex justify-content-center text-center'}> </div>
                <script src={widgetUrl + `/get-script${selectedTenant.tenantUrlEnabled ? '/' + selectedTenant?.url : ''}?` + this.getQuery()} onLoad={() => {
                    this.setState({ scriptLoaded: true })
                }} />
            </div>
        )
    };

    reinitScript = () => {
        this.setState({ showScript: false, scriptLoaded: false }, () => this.setState({ showScript: true }))
    }

    render(
        { name, description, bestFor, selectedProfiles, children, inputs: { linkUrl }, selectedTenant },
        { options: { widget_container_id }, showScript, scriptLoaded }) {
        const query = this.getQuery();
        return (
            <div className="container">
                <h2 className={'mb-3'}>{name}</h2>
                {description && <h6 className={'mb-2'}>{description}</h6>}
                {bestFor && (
                    <h6>
                        <div style={{ gap: '12px' }} className={'d-flex align-items-center mb-2'}>{__('global.best_displayed_on')}: {bestFor?.map?.((bf) => (
                            <div style={{ gap: '6px' }} className={'d-flex align-items-center'}>
                                <div className={'check-icon'} /> <b>{bf}</b>
                            </div>
                        ))}</div>
                    </h6>
                )}
                {children ? children : (<div>Options here</div>)}
                {
                    selectedProfiles.length ? (
                        <div className="code-snippet">
                            <div className={'preview mb-5'}>
                                <div className={'d-flex justify-content-between'} style={{ gap: '15px' }}>
                                    <p>{__('global.preview')}</p>
                                    <Badge text={this.props.badgeTitle} bgColor={this.props.badgeColor} fontColor={this.props.badgeFontColor} smaller />
                                </div>
                                {showScript && (selectedProfiles.length === 1 || (selectedProfiles.length && linkUrl)) ? this.renderScript() : null}
                            </div>
                            {!scriptLoaded ? (
                                <div className="text-center">
                                    {selectedProfiles.length > 1 && !linkUrl
                                        ? (
                                            <div>
                                                {__('inputs.url.required_text')}
                                            </div>
                                        )
                                        : (
                                            <div className="spinner-border text-primary" role="status" style="width: 4rem; height: 4rem;">
                                                <span className="sr-only" />
                                            </div>
                                        )}
                                </div>
                            ) : null}
                            <p className={'code-snippet-title mb-3'}>{__('copy_code_disclaimer')}</p>
                            <div className="pre-code">
                                <CopyButton textRef={this.codeRef} />
                                <code ref={this.codeRef}>
                                    {`<div id="${widget_container_id}"></div><script src="${widgetUrl}/get-script${selectedTenant.tenantUrlEnabled ? '/' + selectedTenant?.url : ''}?${query}"></script>`}
                                </code>
                            </div>
                        </div>
                    ) : null
                }
            </div>
        )
    }
}

export default WidgetPreview
